export default "﻿<div>\n    <div class=\"w3-row\" data-dojo-attach-point=\"audienceSeatingEditContainer\">\n\n    </div>\n</div>"